import axios from "axios";

export default async function getAuthUrl(idOpenData, idUser) {
  let response;
  let config = {
    method: "get",
    url: `${process.env.REACT_APP_URL_GS}/auth`,
    params: {
      id_opendata: idOpenData,
      id_usuario: idUser,
    },
  };

  await axios(config)
    .then(function (res) {
      response = res.data;
    })
    .catch(function (error) {
      response = Promise.reject(error);
    });
  return response;
}
